import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {forwardRef, useContext, useEffect, useState} from "react";

import Meta from "../common/Meta";
import {AppContext} from "../../lib/AppContext";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Footer from "../Footer";
import {getReportByRequest} from "../common/api/ReportApi";
import {CardContent, Chip, Link} from "@mui/material";
import MDTypography from "../../components/MDTypography";
import Loading from "../common/Loading";
import {capitalize, formatCurrency, formatDateMask, formatDateTime} from "../common/Utils";
import BootyPagination from "../common/bootyPagination";
import DataTable from "react-data-table-component";
import * as pagination from "../common/pagination";
import {Controller, useForm} from "react-hook-form";
import Icon from "@mui/material/Icon";
import {BarChart} from '@mui/x-charts/BarChart';
import MDButton from "../../components/MDButton";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import moment from "moment/moment";
import {getCookie, setCookie} from "../common/appCookie";
import Switch from "@mui/material/Switch";
import {Col} from "react-bootstrap";
import FileSelector from "../calendarUI/FilterSelector";
import {CONSTANTS} from "../common/constants";
import AutoCompleteProductSearch from "../client/modal/AutoCompleteProductSearch";
import ViewSaleItemModal from "../inventory/ViewSaleItemModal";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Confirm from "../common/Confirm";
import {archiveSalesItem, getSaleItem} from "../common/api/WebApi";
import StatisticsCard from "./card/StatisticsCard";

export default function SalesReportDetails({type, range, daily}) {

  const widthFn = () => {
    let w = parseInt(window.innerWidth, 10) * .5;
    return parseInt(window.innerWidth, 10) * .5;
  }
  const [docWidth, setDocWidth] = useState(100);

  useEffect(() => {
    function handleWidthFn() {
      setDocWidth(widthFn());
    }

    window.addEventListener("resize", handleWidthFn);
    handleWidthFn();
    return () => window.removeEventListener("resize", handleWidthFn);
  }, []);

  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();
  const [reportPeriod, setReportPeriod] = useState();

  const [reportData, setReportData] = useState();

  const [eventDate, setEventDate] = useState();
  const [eventEndDate, setEventEndDate] = useState();

  const [viewingSale, setViewingSale] = useState(false);
  const [saleItem, setSaleItem] = useState(null);
  const [savingSaleItem, setSavingSaleItem] = useState(false);

  const [showServiceCharge, setShowServiceCharge] = useState(false);

  useEffect(() => {
    if (!context?.sessionUser?.company?.preferences) {
      return;
    }
    setShowServiceCharge('true' === context?.sessionUser?.company?.preferences['include_service_charge'])
  }, [context?.sessionUser?.company?.preferences]);

  const _BootyPagination = {...BootyPagination};
  let {reportYear, reportMonth, reportEndYear, reportEndMonth} = useParams();

  const runReport = () => {
    if (daily) {
      getSalesReportByRangeFn();
      return;
    }

    let _period = reportYear + '/' + reportMonth;
    setReportPeriod(_period);
    let _d = new Date();
    _d.setFullYear(reportYear);
    let m = moment(reportMonth, 'MMM')
    _d.setMonth(m.month());
    _d.setDate(1);
    setEventDate(_d);

    if (!range) {
      setReportEndPeriod(_period);
      setEventEndDate(_d);

      getSalesReportByYearMonthFn(_period);

      return;
    }

    let _endPeriod = reportEndYear + '/' + reportEndMonth;
    setReportEndPeriod(_endPeriod);

    let _dd = new Date();
    _dd.setFullYear(reportEndYear);
    let mm = moment(reportEndMonth, 'MMM')
    _dd.setMonth(mm.month());

    setReportEndPeriod(_endPeriod);
    setEventEndDate(_dd);

    getSalesReportByRangeFn(_period, _endPeriod);


  }
  useEffect(() => {
    runReport();
  }, []);

  useEffect(() => {
    _BootyPagination.reportData = {...reportData};
  }, [reportData]);


  const [labels, setLabels] = useState();
  const [chartData, setChartData] = useState();

  const formatChartData = (report) => {
    setChartData(report?.pieChartData);
    let types = [];
    let _chargeTypes = [];
    for (const j in report?.pieChartData) {
      types.push({
        id: report?.pieChartData[j].id,
        sortOrder: report?.pieChartData[j].id,
        name: report?.pieChartData[j].label
      });
    }

    const uniqueSet = new Set([]);
    for (const k in report?.reportItems) {
      uniqueSet.add(report?.reportItems[k].chargeType?.id);
    }

    let chargeIds = [];
    for (const [k, v] of Object.entries(CONSTANTS.CHARGE_TYPE)) {
      if (uniqueSet.has(v)) {
        let displayName = capitalize((k + '').toLowerCase().replace('_', ' '));
        _chargeTypes.push({
          id: v,
          sortOrder: v,
          name: displayName
        });
      }
    }

    setInventoryTypes(types);
    setChargeTypes(_chargeTypes);

  }

  const getSalesReportByRangeFn = (startPeriod, endPeriod) => {

    setReportData(null);

    let _req = {
      startDate: eventDate ? eventDate : new Date(),
      endDate: eventEndDate ? eventEndDate : new Date()
    }

    getReportByRequest(type, _req)
      // getReportByTypeRange(type, startPeriod, endPeriod)
      .then(r => {
        if (r.error) {
          setContext({...context, error: {message: r.message}});
          setReportData({});
        } else {
          setReportData(r);
          formatChartData(r);
        }
      });
  }

  const getSalesReportByYearMonthFn = (period) => {

    setReportData(null);

    let _d = new Date();
    _d.setFullYear(period.split('/')[0]);
    let m = moment(period.split('/')[1], 'MMM')
    _d.setMonth(m.month());
    _d.setDate(1);

    let _req = {
      startDate: _d
    }

    getReportByRequest(type, _req).then(r => {
      if (r.error) {
        setContext({...context, error: {message: r.message}});
        setReportData({});
      } else {
        setReportData(r);
        formatChartData(r);
      }
    });

  }


  const DisplayReferenceId = ({tableRow}) => {

    const [row, setRow] = useState(tableRow);
    let id = row.referenceId;
    if (!id) {
      return '';
    }
    let descPart = id.substring(0, 3);
    let finalPart = id.substring(id.length - 4, id.length);
    return (
      <span
        className="cursor-pointer"
        onClick={() => {
          let _r = {...row};
          _r.fullId = !!!_r.fullId;
          setRow(_r);
        }}>
        {row.fullId ? <>{id}</> :
          <Chip
            label={descPart + '...' + finalPart}
            variant="outlined"
            color="secondary"

          />
        }
      </span>
    )
  }
  const handleViewCustomer = (row) => {
    navigate('/client/' + row.guid);
  }
  const [confirmation, setConfirmation] = useState();
  const [showArchiveSale, setShowArchiveSale] = useState(false);
  const [archivingSale, setArchivingSale] = useState(false);

  const archiveSale = (saleItem) => {
    getSaleItem(saleItem?.id).then((resp) => {
      setSaleItem(resp);
      setConfirmation({
        title: 'Archive Sale?',
        message: 'Confirm Archive ' + resp?.itemName,
      })
      setShowArchiveSale(true);
    })
  }

  const viewSale = (saleItem) => {
    getSaleItem(saleItem?.id).then((resp) => {
      setSaleItem(resp);
      setViewingSale(true);
    })
  }

  const doArchiveSale = (saleItem) => {
    setArchivingSale(true);
    archiveSalesItem(saleItem).then((resp) => {
      setArchivingSale(false);
      setConfirmation(null);
      setShowArchiveSale(false);
      runReport();
    });
  }

  const saveSaleItem = async () => {
    setSavingSaleItem(false);
    setViewingSale(false);
    runReport();
  }

  const Actions = ({item}) => {
    return (<PopupState variant="popover" popupId={'sales-report-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                viewSale(item)
              }} icon={<Icon>receipt</Icon>} title="View Sale"/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                archiveSale(item)
              }} icon={<Icon>delete</Icon>} title="Archive Sale"/>

          </Menu>
        </>
      )}
    </PopupState>);
  }

  function subTotal(row) {
    if (row.total === 0) {
      return 0;
    }
    return row.total - (row.tax || 0);
  }

  function serviceCharge(row) {
    return row.hasServiceCharge ? subTotal(row) * 0.03 : 0;
  }

  const _columns = [
    {
      name: <span className='th'>Purchase Date</span>,
      id: 1,
      selector: row => new Date(row.purchaseDate).getTime(),
      cell: row => {
        return formatDateTime(row.purchaseDate);
      },
      sortType: (a, b) => {
        return new Date(b.values.purchaseDate) - new Date(a.values.purchaseDate);
      },
      sortable: true,
    },
    {
      name: <span className='th'>Customer</span>,
      id: 2,
      selector: row => row.customer?.lastName + ' ' + row.customer?.firstName,
      cell: row => {
        return <>
          {row.customer.userTypeId === CONSTANTS.UTYPE_CLIENT && <>
            {row.customer?.lastName + (row.customer?.firstName ? ', ' + row.customer?.firstName : '')} (Guest)
          </>}
          {row.customer.userTypeId === CONSTANTS.UTYPE_CUSTOMER && <Link className="link"
                                                                         href={'/client/' + row.customer?.guid}>
            {row.customer?.lastName + (row.customer?.firstName ? ', ' + row.customer?.firstName : '')}
          </Link>}
        </>
      },
      sortable: true,
    },
    {
      name: <span className='th'>Reference Id</span>,
      id: 3,
      selector: row => row.referenceId,
      cell: row => {
        return <DisplayReferenceId tableRow={row}/>;
      },
      width: '120px',
      sortable: true,
    },
    {
      name: <span className='th'>Product Name</span>,
      id: 4,
      selector: row => row.name,
      cell: row => {
        return <>{row.name}</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Inventory Type</span>,
      id: 12,
      selector: row => row.inventoryType?.name,
      cell: row => {
        return <>{row.inventoryType?.name}</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Payment Type</span>,
      id: 13,
      selector: row => row.chargeType?.name,
      cell: row => {
        return <>{row.chargeType?.name}</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Deposit</span>,
      id: 16,
      selector: row => row.depositItem,
      cell: row => {
        return <>{row.depositItem ? 'Yes' : 'No'}</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Location</span>,
      id: 14,
      selector: row => row.location,
      cell: row => {
        return <>{row.location}</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Created By</span>,
      id: 15,
      selector: row => row.createUser,
      cell: row => {
        return <>{row.createUser?.lastName + (row.createUser?.firstName ? ', ' + row.createUser?.firstName : '')}</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Price</span>,
      id: 17,
      selector: row => row.itemPrice,
      right: true,
      cell: row => {
        return <>{formatCurrency(row.itemPrice + (row.discount || 0))} </>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Discount</span>,
      id: 6,
      selector: row => row.discount,
      right: true,
      cell: row => {
        return <>{formatCurrency(row.discount || 0)} </>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Subtotal</span>,
      id: 9,
      selector: row => row.total,
      right: true,
      cell: row => {
        return <>{formatCurrency(row.subTotal)} </>;
      },
      sortable: true,
    },

    {
      name: <span className='th'>Sales Tax</span>,
      id: 8,
      selector: row => row.tax,
      right: true,
      cell: row => {
        return <>{formatCurrency(row.tax - row.refundTax)} </>;
      },
      sortable: true,
    },

    {
      name: <span className='th'>Processing Fee</span>,
      id: 19,
      omit: !showServiceCharge,
      selector: row => row.serviceCharge,
      right: true,
      sortFunction: (a, b) => {
        return serviceCharge(a) > serviceCharge(b) ? 1 : -1
      },
      cell: row => {
        return <>{formatCurrency(serviceCharge(row))} </>;
      },
      sortable: true,
    },

    {
      name: <span className='th'>Total</span>,
      id: 21,
      selector: row => row.total,
      right: true,
      cell: row => {
        return <>{formatCurrency(row.total + serviceCharge(row))} </>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Refund</span>,
      id: 7,
      selector: row => row.refund,
      right: true,
      cell: row => {
        return <>{formatCurrency(row.refund)} </>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Actions</span>,
      id: 18,
      selector: row => row.total,
      right: true,
      cell: row => {
        return <Actions item={row}/>;
      },
      sortable: true,
    },
  ];
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);
  const [columns, setColumns] = useState(_columns);
  const [searchParams, setSearchParams] = useSearchParams();
  const [startPage, setStartPage] = useState(searchParams.get('startPage') || 0);
  const handlePageChange = (selector, page) => {
    setStartPage(selector);
  };

  const [render, setRender] = useState(1);
  const [sortDir, setSortDir] = useState(searchParams.get('sortDir') || 'asc');
  const [sortOrder, setSortOrder] = useState(searchParams.get('sortOrder') || 1);

  const exportCsv = () => {
    let _rows = {...reportData};
    let d = _rows?.reportItems;
    let filename = 'Sales-Export-' + formatDateMask(new Date(), 'MM-DD-YYYY-hh-mm-ss') + '.csv';

    let rows = [];
    let _dd = [];
    _dd.push("Purchase Date");
    _dd.push("Customer Last Name");
    _dd.push("Customer First Name");
    _dd.push("Reference Id");
    _dd.push("Product Name");
    _dd.push("Inventory Type");
    _dd.push("Payment Type");
    _dd.push("Location");
    _dd.push("Created By");

    _dd.push("Price");
    _dd.push("Discount");
    _dd.push("Subtotal");
    _dd.push("Sales Tax");
    _dd.push("Total");
    _dd.push("Refund");

    rows.push(_dd);

    for (let j in d) {
      let _dd = [];
      _dd.push(formatDateTime(d[j].purchaseDate));
      _dd.push(d[j].customer?.lastName);
      _dd.push(d[j].customer?.firstName);
      _dd.push(d[j].referenceId);
      _dd.push(d[j].name);
      _dd.push(d[j].inventoryType?.name);
      _dd.push(d[j].chargeType?.name);
      _dd.push(d[j].location);
      _dd.push(d[j].customer?.lastName + ', ' + d[j].customer?.firstName);

      _dd.push(formatCurrency(d[j].itemPrice + (d[j].discount || 0)));
      _dd.push(formatCurrency(d[j].discount));
      _dd.push(formatCurrency(d[j].total - (d[j].tax || 0)));
      _dd.push(formatCurrency(d[j].tax));
      _dd.push(formatCurrency(d[j].total));
      _dd.push(formatCurrency(d[j].refund));

      rows.push(_dd);
    }

    let data = rows.map(row =>
      row
        .map(String)  // convert every value to String
        .map(v => v.replaceAll('"', '""'))  // escape double quotes
        .map(v => `"${v}"`)  // quote it
        .join(',')  // comma-separated
    ).join('\r\n');

    var blob = new Blob([data], {type: 'text/csv;charset=utf-8;'});
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  const handleSort = (column, sortDirection) => {
    setSortOrder(column.id);
    setSortDir(sortDirection);
    setCookie('SALES_REPORT_SORT', column.id);
    setCookie('SALES_REPORT_SORT_DIR', sortDirection);
    setRender(render + 1);
  };

  const [reportEndPeriod, setReportEndPeriod] = useState();
  const [rangeReport, setRangeReport] = useState(range || false);

  const toggleReportRange = () => {
    setRangeReport(!rangeReport)
  }

  const getReport = () => {
    if (rangeReport) {
      getSalesReportByRangeFn(reportPeriod, reportEndPeriod);
    } else {
      getSalesReportByYearMonthFn(reportPeriod);
    }
  }

  const updateEventDates = (date) => {
    let _d = new Date(date);
    let _period = (_d.getFullYear()) + '/' + formatDateMask(_d, 'MMM');
    setEventDate(_d);
    setReportPeriod(_period);
  }

  const updateEventEndDates = (date) => {
    let _d = new Date(date);
    let _period = (_d.getFullYear()) + '/' + formatDateMask(_d, 'MMM');
    setEventEndDate(_d);
    setReportEndPeriod(_period);
  }
  const [selected, setSelected] = useState();
  const [inventoryTypes, setInventoryTypes] = useState([]);
  const [chargeTypes, setChargeTypes] = useState([]);
  const [inventoryTypeFilter, setInventoryTypeFilter] = useState([]);
  const [chargeTypeFilter, setChargeTypeFilter] = useState([]);

  const [totalSales, setTotalSales] = useState(0);
  const [totalRefunds, setTotalRefunds] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);

  const [inventoryMap, setInventoryMap] = useState();

  const setSalesData = () => {

    const filtered = resultsFiltered(reportData?.reportItems);
    let sales = 0;
    let revenue = 0;
    let tax = 0;
    let refunds = 0;

    const chartData = [];

    for (const j in filtered) {
      sales += parseFloat(filtered[j].total);
      revenue += parseFloat(filtered[j].totalRevenue);
      tax += parseFloat(filtered[j].tax);
      tax -= parseFloat(filtered[j].refundTax);
      refunds += parseFloat(filtered[j].refund);
    }
    const grouped = new Map();
    const inventoryList = new Map();
    for (const item in filtered) {
      const inventory = filtered[item];
      inventoryList.set(inventory, inventory);
      const id = inventory?.inventoryType?.id;
      const label = inventory?.inventoryType?.name;
      const value = inventory?.total;
      if (grouped.has(id)) {
        grouped.get(id).value += value;
      } else {
        grouped.set(id, {id, label, value});
      }
    }

    const aGrouped = Array.from(grouped.values());
    setChartData(aGrouped);
    setTotalSales(sales);
    setTotalTax(tax);
    setTotalRefunds(refunds);
    setTotalRevenue(revenue);
    setInventoryMap(reportData?.inventoryItems.sort((a, b) => a.name.localeCompare(b.name)));
  }

  useEffect(() => {
    setSalesData();
  }, [reportData, inventoryTypeFilter, chargeTypeFilter, selected]);

  const resultsFiltered = (data) => {
    let arr1 = inventoryTypeResultsFiltered(data);
    let arr2 = chargeResultsFiltered(arr1);
    if (selected) {
      let arr3 = [];
      for (let a in arr2) {
        if (selected.id === arr2[a].inventoryGk) {
          arr3.push(arr2[a]);
        }
      }
      return arr3;
    }

    return arr2;
  }

  const inventoryTypeResultsFiltered = (data) => {
    if (!inventoryTypeFilter || inventoryTypeFilter.length === 0) {
      return data;
    }
    let _fd = [];
    for (const j in data) {
      let key = parseInt(data[j]?.inventoryType?.id, 10);
      for (const f in inventoryTypeFilter) {
        if (parseInt(inventoryTypeFilter[f], 10) === key) {
          _fd.push(data[j]);
        }
      }
    }
    return _fd;
  }

  const chargeResultsFiltered = (data) => {
    if (!chargeTypeFilter || chargeTypeFilter.length === 0) {
      return data;
    }
    let _fd = [];
    for (const j in data) {
      let key = parseInt(data[j]?.chargeType?.id, 10);
      for (const f in chargeTypeFilter) {
        if (parseInt(chargeTypeFilter[f], 10) === key) {
          _fd.push(data[j]);
        }
      }
    }
    return _fd;
  }

  const {register, handleSubmit, setValue, control} = useForm({});

  const FormattedDateInput = forwardRef(({value, onClick}, ref) => (
    <span className={'cursor-pointer'} onClick={onClick} ref={ref}>
      <MDTypography variant="h5" color="secondary" fontWeight="light" sx={{
        display: 'inline-block'
      }}>
        <Icon sx={{
          marginTop: '2px',
        }}>event</Icon>Report Date - {formatDateMask(eventDate, 'MMMM yyyy')}
      </MDTypography>
    </span>
  ));

  const valueFormatter = (value) => formatCurrency(value);

  return (

    <DashboardLayout>

      <Meta pageTitle={'Sales Report'}/>

      <ContextSearchNavbar title="Sales Report"/>

      <MDBox py={3}>
        <MDBox mb={3}>

          {!reportData && <Loading/>}
          {reportData && <><Grid container spacing={1} mb={2}>

            <Grid item xs={12} sm={8}>

              <DesktopDatePicker
                sx={{
                  '& .MuiInputBase-root': {
                    borderRadius: '4px 0 0 4px'
                  }
                }}
                closeOnSelect={false}
                views={(rangeReport || daily) ? ['year', 'month', 'day'] : ['month', 'year']}
                maxDate={dayjs()}
                slotProps={{
                  actionBar: {
                    actions: ['today', 'accept'],
                  },
                }}
                value={dayjs(eventDate)}
                onChange={(e) => {
                  updateEventDates(e?.$d || null);
                }}
              />
              {rangeReport &&
                <DesktopDatePicker
                  sx={{
                    '& .MuiInputBase-root': {
                      borderRadius: '4px 0 0 4px'
                    }
                  }}
                  closeOnSelect={false}
                  views={['year', 'month', 'day']}
                  // minDate={dayjs(eventDate)}
                  // maxDate={dayjs()}
                  slotProps={{
                    actionBar: {
                      actions: ['today', 'accept'],
                    },
                  }}
                  value={dayjs(eventEndDate)}
                  onChange={(e) => {
                    updateEventEndDates(e?.$d || null);
                  }}
                />}
              <MDButton
                sx={{
                  borderRadius: '0 4px 4px 0',
                  height: '44px'
                }}
                color="info"
                onClick={() => {
                  getReport();
                }}
              >Go</MDButton>
            </Grid>

            <Grid item xs={12}>
              <Col xs={12}>
                <label
                  htmlFor="rangeReport">
                  Date Range
                  <Switch
                    name={'rangeReport'}
                    id={'rangeReport'}
                    checked={rangeReport}
                    style={{marginRight: '5px'}}
                    onChange={toggleReportRange}
                  /> </label>
              </Col>
            </Grid>
            <Grid item sm={8} xs={12}>
              <Card>
                <CardContent sx={{
                  height: '320px'
                }}>
                  <MDTypography variant="h5" fontWeight={"light"}>
                    Inventory Types
                  </MDTypography>
                  {chartData && <BarChart
                    tooltip={{trigger: 'item'}}
                    grid={{vertical: true, horizontal: true}}
                    dataset={chartData}

                    xAxis={[
                      {
                        scaleType: 'band',
                        dataKey: 'label',
                        colorMap: {
                          type: 'ordinal',
                          colors: ['#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#08589e']
                        }
                      }
                    ]}
                    series={[{dataKey: 'value', valueFormatter}]}
                    width={docWidth}
                    height={300}
                  />}
                </CardContent>
              </Card>
            </Grid>
            <Grid item sm={4} xs={6}>
              <Card>
                <CardContent>
                  <h5>Filters</h5>
                  <div style={{
                    marginLeft: '-2%',
                    paddingRight: '2%',
                  }}>

                    <FileSelector
                      width={'100%'}
                      types={inventoryTypes}
                      typeFilter={inventoryTypeFilter}
                      filterLabel={'Inventory Types'}
                      labelBackground={'#fff'}
                      setFilter={(filters) => {
                        setInventoryTypeFilter(filters)
                      }}
                    />

                    <div style={{
                      marginBottom: '8px'
                    }}>
                      <FileSelector
                        width={'100%'}
                        types={chargeTypes}
                        typeFilter={chargeTypeFilter}
                        filterLabel={'Payment Types'}
                        labelBackground={'#fff'}
                        setFilter={(filters) => {
                          setChargeTypeFilter(filters)
                        }}
                      />
                    </div>
                  </div>

                  {inventoryMap && <MDBox style={{
                    background: '#fff',
                    marginBottom: '6px'
                  }}>
                    <Controller
                      name="inventory"
                      control={control}
                      rules={{required: "Inventory is required"}}
                      render={({field, fieldState}) => (
                        <AutoCompleteProductSearch
                          label="Filter Products"
                          inventoryList={inventoryMap}
                          hidePrice={true}
                          keyValue={'id'}
                          value={field.value}              // Controlled value from RHF
                          onChange={field.onChange}        // Update form state on change
                          fieldState={fieldState}          // For error display
                          // defaultValue={perk?.inventory}  // Optional initial value
                          onSelect={(selected) => {
                            field.onChange(selected);      // Update RHF state on selection
                            setSelected(selected);    // Your local state handler if needed
                          }}
                        />
                      )}
                    />
                  </MDBox>
                  }

                </CardContent>
              </Card>

              {showServiceCharge && <div style={{
                marginTop:'6px'
              }}>
                <StatisticsCard
                  disabled={true}
                  title="Processing Fees"
                  count={formatCurrency(reportData?.serviceFees)}
                  percentage={{
                    color: "success",
                    label: "Total Processing Fees",
                  }}
                />
              </div>
              }

            </Grid>

            <Grid container spacing={1} mt={2}>
              <Grid item xs={6} sm={3}>
                <StatisticsCard
                  title="Gross Sales"
                  count={formatCurrency(totalSales)}
                  percentage={{
                    color: "success",
                    label: "Total Gross Sales for period",
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={3}>

                <StatisticsCard
                  title="Net Sales Revenue"
                  count={formatCurrency(totalRevenue)}
                  percentage={{
                    color: "success",
                    label: "Total Revenue for period",
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={3}>

                <StatisticsCard
                  title="Taxes"
                  count={formatCurrency(totalTax)}
                  percentage={{
                    color: "success",
                    label: "Total Taxes for period",
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={3}>

                <StatisticsCard
                  disabled={true}
                  title="Gift Card (Recognition)"
                  count={formatCurrency(reportData?.giftCardsTotal)}
                  percentage={{
                    color: "success",
                    label: "Total Gift Cards Recognized",
                  }}
                />

              </Grid>

            </Grid>

            <Card sx={{
              marginTop: '15px',
              width: '100%'
            }}>
              <CardContent>

                <MDButton
                  className="pull-right"
                  color="secondary"
                  size="small"
                  onClick={exportCsv}><span className="fa fa-file-excel"></span>&nbsp;Export</MDButton>
                <DataTable
                  striped
                  noDataComponent={<MDTypography variant={'p'} className={'cursor-default'}
                                                 fontWeight={'light'}>No
                    Sales Data Found</MDTypography>}
                  columns={columns}
                  keyField={'id'}
                  data={resultsFiltered(reportData?.reportItems)}
                  onSort={handleSort}
                  highlightOnHover
                  onRowClicked={(row) => {
                    // handleRowClick(row);
                  }}
                  paginationTotalRows={reportData?.reportItems?.length}
                  onChangePage={handlePageChange}
                  progressPending={!reportData}
                  defaultSortFieldId={getCookie('SALES_REPORT_SORT') || 1}
                  defaultSortAsc={getCookie('SALES_REPORT_SORT_DIR') === 'desc' ? false : true}
                  paginationComponentOptions={PaginationOptions}
                />

              </CardContent>
            </Card>

          </Grid>
          </>
          }
        </MDBox>
      </MDBox>
      <Footer mt={5}/>

      {
        confirmation && showArchiveSale && <Confirm confirmation={confirmation}
                                                    show={showArchiveSale}
                                                    saving={archivingSale}
                                                    handleSave={() => {
                                                      setConfirmation(null);
                                                      setShowArchiveSale(false);
                                                    }}
                                                    handleConfirm={() => {
                                                      doArchiveSale(saleItem);
                                                    }}/>
      }

      {viewingSale && <ViewSaleItemModal
        saleItem={saleItem}
        show={viewingSale}
        saving={savingSaleItem}
        handleSave={saveSaleItem}
        handleClose={() => {
          setViewingSale(false);
          setSaleItem(null);
        }}/>}

    </DashboardLayout>
  );
}